"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _webVitals = require("web-vitals");
var _WebVitalRUM = _interopRequireDefault(require("./WebVitalRUM.proptypes"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var WebVitalRUM = function WebVitalRUM(props) {
  var fireGtm = props.fireGtm;
  function sendToGTM(_ref) {
    var name = _ref.name,
      delta = _ref.delta,
      id = _ref.id;
    var obj = {
      event: 'pagePerformance',
      'eventDetails.category': "web vital",
      'eventDetails.action': "".concat(name),
      'eventDetails.label': "".concat(id),
      'eventDetails.value': delta
    };
    if (fireGtm) {
      fireGtm(obj);
    }
  }
  (0, _react.useEffect)(function () {
    (0, _webVitals.getCLS)(sendToGTM, true);
    (0, _webVitals.getFID)(sendToGTM);
    (0, _webVitals.getLCP)(sendToGTM);
    (0, _webVitals.getTTFB)(sendToGTM);
    (0, _webVitals.getFCP)(sendToGTM);
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
WebVitalRUM.propTypes = _WebVitalRUM.default.PropTypes;
var _default = WebVitalRUM;
exports.default = _default;